/**
 * Collection hero filter bar — toggles .scrolled while the bar is stuck
 * under the navbar. Loaded with defer; runs when the script is parsed
 * (DOM ready).
 */
(function () {
  const stickyBar = document.querySelector('.collection-hero__filter-container');
  const stickyWrap = document.querySelector('.collection-hero__filter-sticky');

  if (!stickyBar || !stickyWrap) {
    return;
  }

  const getNavHeight = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--nav-height');
    return parseFloat(value) || 0;
  };

  const update = () => {
    const stuck = stickyWrap.getBoundingClientRect().top <= getNavHeight() + 1;
    stickyBar.classList.toggle('scrolled', stuck);
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
